// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SnN4","colBig":"styles_colBig__1GzNK","colSmall":"styles_colSmall__3qu4v","shopifyNameWrapper":"styles_shopifyNameWrapper__16mHk"};